
import styles from './ListItemWithImage.module.css';
import { useTranslation } from 'react-i18next';
import { formatClientNameWithCount, isNewClient, isVipClient } from '../../shared/utils/clientDisplay';

const statusConfig = {
	COMPLETED: { color: '#45c343', label: 'command.completed' },
	ACKNOWLEDGED: { color: '#4d5ec4', label: 'command.accepted' },
	REACHED: { color: '#1c9dff', label: 'command.reached' },
	// STARTED: { color: '#8fa9b9', label: 'command.started' },
	CANCELED: { color: '#FF0000', label: 'status.CANCELED' },
	FAILED: { color: '#FF0000', label: 'status.FAILED' },
	DECLINED: { color: '#FF69B4', label: 'status.DECLINED' },
	IN_TRANSIT: { color: '#393d44', label: 'command.road' },
	CREATED: { color: '#8fa9b9', label: 'command.created' },
	DEFAULT: { color: '#ff8a00', label: 'tabs.assigned' },
};


const ListItemWithImage = ({ bookingItem, date, time, title, description, status, bstatus }) => {
	const { t } = useTranslation(['dashboard']);
	const imageUrl = bookingItem?.therapist?.media?.[0]?.original_url;
	const currentStatus = statusConfig[bstatus] || statusConfig.DEFAULT;
	const client = bookingItem?.booking?.client;
	const clientName = formatClientNameWithCount(client, title);
	const clientLabels = [
		isVipClient(client) ? t('table.vip') : null,
		isNewClient(client) ? t('table.newClientValue') : null,
	].filter(Boolean);

	return (
		<div className={styles.listItemWithImage}>
			{imageUrl ? (
				<img className={styles.imageMedia} src={imageUrl} alt="Therapist" />
			) : (
				<div className={styles.imageIcon} /> // fallback if no image
			)}
			<div className={styles.text}>
				<div className={styles.title}>
					<div className={styles.rating}>
						<div className={styles.div}>{date}</div>
					</div>
					<div className={styles.rating1}>
						<div className={styles.div}>{time}</div>
					</div>
					<div className={styles.foremIpsum}>{bookingItem.booking?.hotel ? bookingItem.booking?.hotel?.name : clientName}</div>
					{clientLabels.length > 0 && (
						<div className={styles.clientFlags}>{clientLabels.join(' | ')}</div>
					)}
					<div className={styles.rating2}>
						<div className={styles.div}>{description}</div>
					</div>
				</div>
			</div>
			<div className={styles.tags}>
				<div className={status === 'Terminé' ? styles.tags2 : styles.tags1} style={{backgroundColor: currentStatus.color, color: '#FFF', width: 'max-content'}}>
					<b className={styles.assigned}>{t(currentStatus.label)}</b>
				</div>
			</div>
		</div>);
};

export default ListItemWithImage;
